<template>
<div>
  <document-print ref="document_print"/>
  <div v-if="show_document && form.iin !== '' && form.account !== ''">
    <div v-if="!$store.state.current_document">
      <b-icon icon="arrow-clockwise" animation="spin" font-scale="4"></b-icon>
    </div>
    <div>
      <b-button @click.stop.prevent="hideDocument" class="print-button mt-1 ms-1"><b-icon-arrow-left class="me-1"></b-icon-arrow-left>Назад</b-button>
      <b-button @click.stop.prevent="getDocument" class="print-button mt-1 ms-1"><b-icon-arrow-repeat class="me-1"></b-icon-arrow-repeat>Обновить</b-button>
      <b-button v-if="$store.state.current_document.accepted === null && $store.state.current_document.document_type_id !== 5" @click.stop.prevent="documentAccept(false)" variant="danger" class="print-button mt-1 ms-1"><b-icon-x class="me-1"></b-icon-x>Отклонить</b-button>
      <b-button v-if="$store.state.current_document.accepted === null && $store.state.current_document.document_type_id !== 5" @click.stop.prevent="documentAccept(true)" variant="success" class="print-button mt-1 ms-1"><b-icon-check class="me-1"></b-icon-check>Принять</b-button>
      <b-button class="print-button mt-1 ms-1" variant="primary" @click="print"><b-icon-printer class="me-1"></b-icon-printer>Печать</b-button>
    </div>
  </div>
  <div v-else>
    <div v-if="$store.state.document_list.length !== 0">
      <b-table striped hover :items="$store.state.document_list" :fields="list_documents_fields">
        <template v-slot:cell(actions)="data">
          <span>
            <b-button class="me-2" variant="info" @click.stop.prevent="selectCurrentDocument(data.item.account_id, data.item.period_id, data.item.document_type_id)"><b-icon-receipt class="me-1"/>Открыть</b-button>
          </span>
        </template>
        <template v-slot:cell(status)="data">
          <span>
            <b-icon-check v-if="data.item.accepted == true" scale="2" class="ms-1" v-b-tooltip.hover title="Принят"></b-icon-check>
            <b-icon-x v-if="data.item.accepted == false" scale="2" class="ms-1" v-b-tooltip.hover title="Отклонен"></b-icon-x>
            <b-icon-pen v-if="!data.item.return_date" class="ms-1" v-b-tooltip.hover title="Подписанный документ не возвращен"/>
            <b-icon-pen-fill v-else class="ms-1" v-b-tooltip.hover :title="`Возвращен ${data.item.return_date}`"/>
            <b-icon-envelope-fill class="ms-2" v-if="data.item.email_send_date" v-b-tooltip.hover :title="`Отправлен ${data.item.email_send_date} на ${data.item.email_to}`"/>
          </span>
        </template>
      </b-table>
      <b-button v-if="$store.getters.isLoggedIn" class="print-button mt-1" variant="info" @click="$router.push('/')"><b-icon-arrow-left class="me-1"></b-icon-arrow-left>Назад</b-button>
      <b-button class="print-button mt-1 ms-1" variant="info" @click="getDocumentList"><b-icon-arrow-repeat class="me-1"></b-icon-arrow-repeat>Обновить</b-button>
  <!--    <b-button class="print-button mt-1 ms-1" variant="primary" @click="print"><b-icon-printer class="me-1"></b-icon-printer>Печать</b-button>-->
    </div>
    <div v-else class="center-element">
      <b-card-group deck align="center">
        <b-card style="max-width: 20rem;">
          <b-card-header class="border-bottom-0">Запрос документов</b-card-header>
          <b-card-text>
            <form @submit.prevent="getDocumentList">
              <div>
                <b-form-input class="mt-1" type="text" name="account_id" v-model="form.account" placeholder="ЛС BTCom"/>
                <b-form-input class="mt-1" type="text" name="iin" v-model="form.iin" placeholder="ИИН"/>
              </div>
            </form>
            <p class="alert-danger" v-if="$store.state.login_error" id="error">{{$store.state.login_error}}</p>
          </b-card-text>
          <b-button variant="success" type="submit" @click.prevent.stop="getDocumentList">Запрос</b-button>
        </b-card>
      </b-card-group>
    </div>
  </div>
</div>
</template>

<script>

import DocumentPrint from "@/components/DocumentPrint.vue";

export default {
  name: "DocumentView",
  components: {DocumentPrint},
  data() {
    return {
      form:{
        account: '',
        iin:''
      },
      current: {
        account_id: null,
        period_id: null,
        document_type_id: null
      },
      show_document: false,
      current_document_type: null,
      list_documents_fields: [
          {key: 'document_name', label: 'Тип документа'},
          {key: 'number', label: 'Номер'},
          {key: 'doc_date', label: 'Дата документа'},
          {key: 'create_date', label: 'Сформирован'},
          {key: 'actions', label: 'Открыть'},
          {key: 'status', label: 'Статусы'}
      ],
    }
  },
  methods:{
    print: function (){window.print()},
    account: function (){
      return this.$store.state.current_receipt ? this.$store.state.current_receipt : null
    },
    getDocumentList: function (){
      this.$store.dispatch('getDocumentList', {'account_id': this.form.account, 'iin': this.form.iin})
    },
    getDocument: function (){
      this.showDocument()
      this.$store.dispatch('clearCurrentDocument')
      this.$store.dispatch('getDocument', {'account_id': this.current.account_id, 'iin': this.form.iin,
        'period_id': this.current.period_id, 'document_type_id': this.current.document_type_id})
    },
    validAccount: function(){
      return true
    },
    selectCurrentDocument: function (account_id, period_id, document_type_id){
      this.current.account_id = account_id
      this.current.period_id = period_id
      this.current.document_type_id = document_type_id
      this.getDocument()
      console.log(this.$refs.document_print)
      this.$refs.document_print.set_doc_type(document_type_id)
    },
    showDocument: function (){
      this.show_document = true;
    },
    hideDocument: function (){
      this.show_document = false;
      this.resetCurrentDocument()
    },
    resetCurrentDocument(){
      this.current.account_id = null
      this.current.period_id = null
      this.current.document_type_id = null
      this.$refs.document_print.set_doc_type(this.current.document_type_id)
    },
    isNumeric(str) {
      if (typeof str != "string") return false
      return !isNaN(str) && !isNaN(parseFloat(str))
    },
    documentAccept: function(state){
      this.$store.state.current_document.accepted = state;
      this.$store.dispatch('setDocumentAcceptState', {'account_id': this.current.account_id, 'iin': this.form.iin,
        'document_id': this.$store.state.current_document.id, 'accept_document': state})
    }
  },
  computed:{
    validBin(){
      if (this.isNumeric(this.form.iin)){return true} else {return false}
      // if (this.form.iin.length > 0){
      //   return this.form.iin.length < 12 ? false : true
      // } else {
      //   return null
      // }
    },
  },
  mounted() {
    console.log('$route', this.$route.params)
    if (this.$route.params.account_id){
      console.log('account_id')
      let params = {}
      if (this.isNumeric(this.$route.params.account_id)
          && this.$route.params.account_id.length >= 5
          && this.$route.params.account_id.length <= 7){
        params.account_id = this.$route.params.account_id
      }
      if (this.isNumeric(this.$route.params.period_id)
          && this.$route.params.period_id.length === 6){
        params.period_id = this.$route.params.period_id
      }
      if (JSON.stringify(params) !== '{}'){
        setTimeout(this.$store.dispatch, 1000, 'getCurrentReceipt', params)
      }
    }
  }
}
</script>

<style scoped>

@media  print{
  @page { margin: 0; size: landscape;}
  body { margin: 1.6cm; }
  .print-button {display: none}
}

.center-element {
  position: fixed; /* or absolute */
  top: 20%;
  left: 42%;

}

</style>